import React, { useState } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";

const CookieNotice = () => {
  const [hide, setHide] = useState(false);

  if (hide) return null;
  return (
    <Wrapper>
      <Inner>
        <h3>
          This site uses tracking technologies. You may opt in or opt out of the
          use of these technologies.
        </h3>
        <button
          type="button"
          onClick={() => {
            localStorage.setItem("consentGranted", true);
            function gtag() {
              window.dataLayer.push(arguments);
            }
            gtag("consent", "update", {
              ad_user_data: "granted",
              ad_personalization: "granted",
              ad_storage: "granted",
              analytics_storage: "granted",
            });

            // Google Tag Manager
            var gtmScript = document.createElement("script");
            gtmScript.async = true;
            gtmScript.src =
              "https://www.googletagmanager.com/gtm.js?id=GTM-N4JTXVJC";

            var firstScript = document.getElementsByTagName("script")[0];
            firstScript.parentNode.insertBefore(gtmScript, firstScript);
            
            setHide(true);
          }}
        >
          Accept all
        </button>
        <button
          type="button"
          onClick={() => {
            localStorage.setItem("consentGranted", false);
            setHide(true);
          }}
        >
          Deny
        </button>
      </Inner>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: fixed;
  bottom: 0.5rem;
  left: 0.5rem;
  z-index: 99999999999999;
  width: calc(100% - 1rem);
  padding: 1rem;
  background: #fff;
  border-radius: 4px;
  border: 1px solid #b1c4dd;
`;
const Inner = styled.div`
  max-width: 1380px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  @media (max-width: 992px) {
    flex-direction: column;
  }
  h3 {
    font-size: 15px;
    color: #686a7d;
    font-weight: 400;
    margin-right: 1.5rem;
    text-align: center;
  }
  a {
    color: #262a68;
  }
  button {
    display: flex;
    cursor: pointer;
    background: #fff;
    color: #262a68;
    border-radius: 4px;
    border: 2px solid #262a68;
    padding: 1rem 3rem;
    font-family: "Inter";
    font-weight: 600;
    height: max-content;
  }
`;

export default CookieNotice;
